import axiosHttp from "services/axiosHttp";

// Employee Service Functions
export const employeeService = {
  // Fetch all employees (limited data)
  fetchEmployees: async () => {
    const response = await axiosHttp.get(`employee/list/all-limited`);
    return response.data;
  }
};
